import store from '../store'

class Notifications {
  notifications = []

  // constructor () {}

  add (payload) {
    store.dispatch('notifications/add', payload)
  }

  remove (index) {
    store.dispatch('notifications/remove', index)
  }
}

export default Notifications



// WEBPACK FOOTER //
// ./src/services/notifications.js